import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { css, nothing, html } from "lit";
import { DsfNavbarItem } from "../NavbarItem/index.js";
import "../Logo/index.js";
import "../IconButton/index.js";
import "../../atom/Row/index.js";
import { navbarClasses, navbarWrapperClasses, logoClasses, slotClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfNavbar = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_disable_collapse = false;
    this.dsf_collapsed = false;
    this.dsf_mobile = false;
  }
  async update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("dsf_collapsed")) {
      await this.updateChildren();
    }
  }
  async toggleCollapse(collapsed) {
    this.emit(collapsed ? "collapse" : "expand");
    this.dsf_collapsed = collapsed;
  }
  async updateChildren(children = this.children) {
    await this.updateComplete;
    Array.from(children).filter((child) => child instanceof DsfNavbarItem).forEach(async (child) => {
      const navbarItem = child;
      if (navbarItem.dsf_collapsed !== this.dsf_collapsed) {
        navbarItem.dsf_collapsed = this.dsf_collapsed;
      }
      if (navbarItem.dsf_open === true) {
        navbarItem.dsf_open = false;
      }
      if (navbarItem.children.length > 0) {
        await this.updateChildren(navbarItem.children);
      }
    });
  }
  renderCollapseButton() {
    if (this.dsf_disable_collapse) {
      return nothing;
    }
    return html`<dsf-navbar-item
      @click=${() => this.toggleCollapse(!this.dsf_collapsed)}
      dsf_icon=${this.dsf_collapsed ? "ArrowRightFromLine" : "ArrowLeftFromLine"}
      .dsf_title=${this.dsf_collapsed ? this.dsf_expand_text : this.dsf_collapse_text}
      .dsf_collapsed=${this.dsf_collapsed}
      class="dsf-p-l mt-auto w-full"
    >
    </dsf-navbar-item>`;
  }
  onLogoClick() {
    this.emit("logo-click");
  }
  onClose() {
    this.emit("close");
  }
  async onSlotChange() {
    await this.updateChildren();
  }
  renderNavbar() {
    const title = (this.dsf_collapsed ? this.dsf_collapsed_title || this.dsf_title : this.dsf_title) || "";
    return html`
      <div class=${navbarClasses(this)}>
        <div class=${navbarWrapperClasses(this)}>
          <button class=${logoClasses(this)} @click=${this.onLogoClick}>
            <dsf-logo .dsf_mobile=${this.dsf_collapsed} .dsf_title=${title}></dsf-logo>
          </button>
          ${this.dsf_mobile ? html`<dsf-icon-button @click=${this.onClose} dsf_icon="X"></dsf-icon-button>` : nothing}
        </div>
        <div class=${slotClasses(this)}>
          <slot @slotchange=${this.onSlotChange}></slot>
        </div>

        ${!this.dsf_mobile ? this.renderCollapseButton() : nothing}

        <slot name="footer"></slot>
      </div>
    `;
  }
  render() {
    if (this.dsf_mobile) {
      return html`
        <dsf-row class="mobile">
          <div @click=${this.onClose} class="backdrop flex h-full w-full"></div>
          ${this.renderNavbar()}
        </dsf-row>
      `;
    }
    return this.renderNavbar();
  }
};
DsfNavbar.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfNavbar.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        min-height: 100%;
        z-index: var(--dsf-z-index-dropdown);
      }

      ::slotted([slot='footer']) {
        margin-top: auto;
      }

      .mobile {
        z-index: var(--dsf-z-index-layout);
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }

      .backdrop {
        background: rgba(var(--dsf-color-neutral-700), 0.5);
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfNavbar.prototype, "dsf_title", 2);
__decorateClass([
  prop({ type: String })
], DsfNavbar.prototype, "dsf_collapsed_title", 2);
__decorateClass([
  prop({ type: Boolean })
], DsfNavbar.prototype, "dsf_disable_collapse", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfNavbar.prototype, "dsf_collapsed", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfNavbar.prototype, "dsf_mobile", 2);
__decorateClass([
  prop({ type: String })
], DsfNavbar.prototype, "dsf_collapse_text", 2);
__decorateClass([
  prop({ type: String })
], DsfNavbar.prototype, "dsf_expand_text", 2);
DsfNavbar = __decorateClass([
  defineElement("dsf-navbar")
], DsfNavbar);
export {
  DsfNavbar
};
